import * as React from "react";

function SvgIcons8Iphone(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#E38939"
        d="M12 40V8c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v32c0 2.2-1.8 4-4 4H16c-2.2 0-4-1.8-4-4z"
      />
      <path
        fill="#FFF3E0"
        d="M32 7H16c-.6 0-1 .4-1 1v29c0 .6.4 1 1 1h16c.6 0 1-.4 1-1V8c0-.6-.4-1-1-1z"
      />
      <path fill="#A6642A" d="M24 39.5a1.5 1.5 0 100 3 1.5 1.5 0 100-3z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Iphone);
